var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("© Copyright 2016-2021 www.100doc.com.cn All right reserved.")])}
var staticRenderFns = []

export { render, staticRenderFns }